export const createColumns = vm => {
  return [
    {
      title: "排名",
      key: "number",
      render: (h, { row: { number } }) => {
        if ([1, 2, 3].includes(number)) {
          return h("img", {
            attrs: {
              alt: "chart" + number,
              src: require("@/assets/competition/chart-" + number + "-2x.png")
            },
            style: {
              width: "40px",
              height: "40px"
            }
          });
        } else {
          return h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "40px",
                height: "40px",
                "line-height": "40px",
                "text-align": "center"
              }
            },
            number
          );
        }
      }
    },
    {
      title: "队伍名称",
      key: "team_name"
    },
    {
      title: "得分",
      key: "score"
    }
  ];
};



// WEBPACK FOOTER //
// ./src/gtn/views/financialCompetitionViews/components/rankingList/config.js